export type EmptyObject = {zz_IGNORE_ME?: never};
